<template>
  <material-card
    v-bind="$attrs"
    class="v-card--material-chart"
    full-header
  >
    <template #heading>
      <div class="pa-4">
        <chartist
          :data="data"
          :event-handlers="eventHandlers"
          :options="options"
          :ratio="ratio"
          :responsive-options="responsiveOptions"
          :type="type"
          style="height: 180px; max-height: 180px;"
        />
        <div
          v-if="seriesLabels.length"
          class="chart-legend"
        >
          <span
            v-for="(label, index) in seriesLabels"
            :key="label"
            class="chart-legend-item"
          >
            <span :class="['chart-legend-swatch', `chart-legend-swatch-${index}`]" />
            {{ label }}
          </span>
        </div>
      </div>
    </template>

    <template #subtitle>
      <slot name="subtitle" />
    </template>

    <template #headerActions>
      <slot name="headerActions" />
    </template>

    <slot />

    <template #actions>
      <slot name="actions" />
    </template>
  </material-card>
</template>

<script>
  export default {
    name: 'MaterialChartCard',

    inheritAttrs: false,

    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      eventHandlers: {
        type: Array,
        default: () => ([]),
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      seriesLabels: {
        type: Array,
        default: () => ([]),
      },
      ratio: String,
      responsiveOptions: {
        type: Array,
        default: () => ([]),
      },
      type: {
        type: String,
        required: true,
        validator: v => ['Bar', 'Line', 'Pie'].includes(v),
      },
    },
  }
</script>

<style lang="sass">
  .v-card--material-chart
    p
      color: #999

    .v-card--material__sheet
      max-height: none
      width: 100%

      .ct-label
        color: rgba(255, 255, 255, 1)
        opacity: .7
        font-size: 0.875rem
        font-weight: 300

      .ct-label.ct-vertical
        white-space: nowrap
        font-size: 0.75rem

      .ct-series-b .ct-point,
      .ct-series-b .ct-line,
      .ct-series-b .ct-bar
        stroke: #ffb3ba

      .ct-series-c .ct-point,
      .ct-series-c .ct-line,
      .ct-series-c .ct-bar
        stroke: #ffe082

      .ct-grid
        stroke: hsla(0,0%,100%,.2)

      .ct-series-a .ct-point,
      .ct-series-a .ct-line,
      .ct-series-a .ct-bar,
      .ct-series-a .ct-slice-donut
          stroke: rgba(255,255,255,.8)

      .ct-series-a .ct-slice-pie,
      .ct-series-a .ct-area
          fill: rgba(255,255,255,.4)
</style>

<style scoped>
.chart-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-top: 8px;
  color: white;
  font-size: 0.75rem;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chart-legend-swatch {
  display: inline-block;
  width: 14px;
  height: 4px;
  background: rgba(255, 255, 255, 0.8);
}

.chart-legend-swatch-1 {
  background: #ffb3ba;
}

.chart-legend-swatch-2 {
  background: #ffe082;
}
</style>
